
import angular from 'angular';

import emailEditor from './email-editor';

export default angular.module('directive.email-editor', [])
	.controller('emailEditorController', function() {})
	.directive('emailEditor', emailEditor)
	.name;



// WEBPACK FOOTER //
// ./src/directive/email-editor/index.js